import {
    allVariants,
    collection,
    parentTypeFor,
    refs,
    routePath,
} from "../_variants/index.js";

import ItemListView from "../../../components/ItemListView/ItemListView.vue"
import ItemView from "../../../components/ItemView/ItemView.vue"
import { appConfig } from "../../../utils.js";
import effectivitiesAttachable from "../Effectivities/attachable.js";
import { makeDocumentsAttachable } from "../Documents/attachable.js";
import { makeDrawingAttachable } from "../Drawings/attachable.js";
import { time } from "../../standardAttachables";

const dataFields = [{
    "label": "Number",
    "key": "Number"
}, {
    "label": "Parent",
    "key": "Parent",
    "link": "Database/:ParentType/:ParentID"
}, {
    "label": "Is Resolved?",
    compute( {item} ) {
        return `<span class="font-bold ${item.Signedoff ? 'text-green' : 'text-red'}">${item.Signedoff ? 'Resolved' : 'Unresolved'}</span>`
    }
}, {
    "label": "Comment",
    "key": "Comment",
    "class": "md:col-span-3"
}];

const menuActions = [];

/**
 * Build the list + detail vue-router routes for the Concession register
 * matching the supplied variant.
 *
 * @param {import("../_variants/index.js").Variant} variant
 */
export const makeConcessionRoutes = (variant) => {
    const isMilitary = variant.key === "military";
    const labelSingular = isMilitary ? "Military Concession" : "Concession";
    const labelPlural = isMilitary ? "Military Concessions" : "Concessions";
    const conParentType = parentTypeFor(variant, "Concessions");
    const listPath = routePath(variant, "Concessions");

    return [{
        "path": listPath,
        "component": {...ItemListView},
        "name": labelPlural,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "sideNav": true,
            "sideNavSection": "Design Items",
            "appSwitcher": false,
            "icon": variant.appIcon,
            "tableSettings": conParentType,
            "dataPath": refs(variant, "Concessions"),
            ...(appConfig.useElasticsearchLists && variant.collectionPrefix === "" ? { "esType": "Concessions" } : {}),
            "selectionRoute": `Database/${conParentType}/{ID}`
        }
    }, {
        "path": `${listPath}/:id`,
        "component": ItemView,
        "name": labelSingular,
        "meta": {
            "app": variant.app,
            "name": labelPlural,
            "dataPath": collection(variant, "Concessions"),
            "selectionRoute": `Database/${conParentType}/{ID}`,
            title(item) {
                return `${labelPlural}: ${item.Number}`
            },
            "attachedItems": {
                "Attached Items": {
                    "attachables": [makeDocumentsAttachable(variant), makeDrawingAttachable(variant), effectivitiesAttachable]
                },
                "Additional Information": {
                    "attachables": [time]
                }
            },
            "dataFields": dataFields,
            "menuActions": menuActions,
            "formMetadata": {
                "ParentType": conParentType
            }
        }
    }];
};

export default allVariants().flatMap(makeConcessionRoutes);
